function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function openCart() {
    document.body.classList.add('cart-opened');
}

function closeCart() {
    document.body.classList.remove('cart-opened');
}

function showLoader() {
    const loader = document.querySelector('.bins-cart-loader');
    if (loader) {
        loader.classList.add('is-visible');
    }
}

function hideLoader() {
    const loader = document.querySelector('.bins-cart-loader');
    if (loader) {
        loader.classList.remove('is-visible');
    }
}

function formatPrice(num) {
    return Number(num).toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

const VAT_RATE = 0.20;

function addVat(price) {
    return price * (1 + VAT_RATE);
}

function removeVat(price) {
    return price / (1 + VAT_RATE);
}

function isVatIncluded() {
    return $('#vat-switch').is(':checked');
}

async function getVariant(variant_id) {
    try {
        const response = await fetch(
            "https://app.recyclingbins.co.uk/api/get-variant", {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    variant_id
                }),
            }
        );
        
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }        
        
        const data = await response.json();
        console.log(data);
        return data;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        throw error;
    }
}

async function renderCartDrawer(startTime) {
    let sub_total = 0;

    try {
        const res = await fetch(window.Shopify.routes.root + "cart.js");
        const cart = await res.json();

        const $itemsContainer = $(".bins-cart-items");
        const $totalsContainer = $(".bins-cart-totals");

        let itemsHTML = '';

        if (cart.items.length) {
            for (const item of cart.items) {
                let item_title = item.product_title;
                let item_image = item.featured_image.url;
                let item_price = item.price;
                let item_handle = item.handle;

                if (item_price === 0 || item_title === undefined) {
                    const variant_data = await getVariant(item.variant_id);
                    console.log(variant_data);

                    item_title = variant_data.title;
                    item_image = variant_data.image;
                    item_handle = variant_data.handle;
                    item_price = variant_data.price * variant_data.qtty;
                } else {
                    item_price = item.presentment_price * item.quantity;
                    item_image = item.image;
                }

                sub_total += item_price;

                const formattedPrice = formatPrice(item_price.toFixed(2));

                let propertiesHtml = '';
                for (const key in item.properties) {
                    if (item.properties[key]) {
                        propertiesHtml += `
                            <p class="item-property">
                                <span>${key}:</span> ${item.properties[key]}
                            </p>
                        `;
                    }
                }

                // 🔥 build string instead of append
                itemsHTML += `
                    <div class="bins-cart-item cwrap" data-id="${item.id}">
                        <div class="cart-item-image">
                            <a href="/products/${item_handle}">
                                <img src="${item_image}" alt="${item_title}">
                            </a>
                        </div>
                        <div class="cart-item-details cwrap">
                            <div class="cart-item-left">
                                <h3 class="cart-item-title">
                                    <a href="/products/${item_handle}">${item_title}</a>
                                </h3>
                                <div class="cart-item-options">
                                    ${propertiesHtml}
                                </div>
                                <div class="qtty">
                                    <span class="minus">-</span>
                                    <input type="text" name="qtty" value="${item.quantity}">
                                    <span class="plus">+</span>
                                </div>
                            </div>
                            <div class="cart-item-right">
                                <p class="cart-item-price">£${formattedPrice}</p>
                                <a href="#" class="cart-item-remove">Remove</a>
                            </div>
                        </div>
                    </div>
                `;
            }

            // ✅ ONE DOM write instead of many
            $itemsContainer.html(itemsHTML);

            const vatAmount = sub_total * 0.20;
            const totalWithVAT = sub_total + vatAmount;

            $totalsContainer.html(`
                <div class="bins-total cwrap">
                    <p><strong>Sub Total</strong></p>
                    <p>£${formatPrice(sub_total.toFixed(2))}</p>
                </div>
                <div class="bins-total cwrap">
                    <p><strong>VAT</strong></p>
                    <p>£${formatPrice(vatAmount.toFixed(2))}</p>
                </div>
                <div class="bins-total cwrap">
                    <p><strong>Total (with VAT)</strong></p>
                    <p>£${formatPrice(totalWithVAT.toFixed(2))}</p>
                </div>
            `);

            $('.cart-count').text(cart.item_count);
            $('.bins-cart-float').show();

        } else {
            $itemsContainer.html(`
                <div class="bins-cart-empty">
                    <h3>Your basket is currently empty.</h3>
                    <p>Looks like you haven't added anything yet.</p>
                    <a href="/collections/all" class="button">Shop Now</a>
                </div>
            `);

            $totalsContainer.empty();
            $('.cart-count').text('');
            $('.bins-cart-float').hide();
        }

        const elapsed = (performance.now() - startTime) / 1000;
        console.log(`Total add-to-cart flow took ${elapsed.toFixed(2)} seconds`);

        hideLoader();

    } catch (err) {
        console.error("Cart fetch error:", err);
    }
}

$(document).ready(function () {
    const winWidth = window.innerWidth;

    if (winWidth < 1201) {
        const info = document.querySelector(".info");

        if (!info) return;

        const track = document.createElement("div");
        track.className = "info-slider-track";

        while (info.firstElementChild) {
            track.appendChild(info.firstElementChild);
        }

        info.appendChild(track);

        const speed = 500;
        const delay = 4000;

        function nextSlide() {
            function nextSlide() {
                track.style.transform = "translateX(-100%)";

                setTimeout(() => {
                    track.appendChild(track.firstElementChild);

                    track.style.transition = "none";
                    track.style.transform = "translateX(0)";

                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            track.style.transition = `transform ${speed}ms ease`;
                        });
                    });
                }, speed);
            }
        }

        setInterval(nextSlide, delay);
    }

    if ($('.tab-products').length) {
        $('.tab-products').slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1201,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 580,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    if ($('.case-slider').length) {
        $('.case-slider').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            rows: 0,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
});

function updatePrices(selector, withVat) {
    document.querySelectorAll(selector).forEach(el => {
        const unitPrice = parseFloat(el.dataset.price);
        const price = withVat ? addVat(unitPrice) : unitPrice;

        el.textContent = '£' + formatPrice(price);
    });
}

function changeBestSellers(withVat) {
    updatePrices('.best-sellers .pprice span', withVat);
}

function changeFCPrice(withVat) {
    updatePrices('.featured-collections p span', withVat);
}

function changeCollectionPrice(withVat) {
    updatePrices('.product-card .pprice span', withVat);
}

async function updateCart(itemId, quantity) {
    try {
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                updates: {
                    [itemId]: quantity
                }
            })
        });

        renderCartDrawer();
    } catch (error) {
        console.error('Error:', error);
    }
}

function loadTidio() {
    const script = document.createElement('script');
    script.src = 'https://code.tidio.co/4t28h01fwfvtgd1syhgcpdwvjry2jx8z.js';
    script.async = true;
    script.defer = true;
    
    script.onload = function() {
        console.log('Tidio loaded successfully');
        openTidioChat();
    };
    
    script.onerror = function() {
        console.error('Failed to load Tidio');
    };
    
    document.head.appendChild(script);
}

function openTidioChat() {
    if (window.tidioChatApi) {
        window.tidioChatApi.open();
        console.log('Tidio chat opened');
    } else {
        let attempts = 0;
        const maxAttempts = 20;
        const interval = setInterval(function() {
            attempts++;
            if (window.tidioChatApi) {
                window.tidioChatApi.open();
                console.log('Tidio chat opened (delayed)');
                clearInterval(interval);
            } else if (attempts >= maxAttempts) {
                console.error('Tidio API not available after waiting');
                clearInterval(interval);
            }
        }, 500);
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector(".home-slider");
    
    if (slider) {
        const slides = slider.querySelectorAll(".home-slide");
        const nextBtn = slider.querySelector(".home-slider-nav .slide-next");
        const prevBtn = slider.querySelector(".home-slider-nav .slide-prev");

        let current = 0;

        function showSlide(index) {
            slides.forEach(slide => slide.classList.remove("active"));
            slides[index].classList.add("active");
        }

        function nextSlide() {
            current = (current + 1) % slides.length;
            showSlide(current);
        }

        function prevSlide() {
            current = (current - 1 + slides.length) % slides.length;
            showSlide(current);
        }

        showSlide(current);

        if (nextBtn) {
            nextBtn.addEventListener("click", function (e) {
                e.preventDefault();
                nextSlide();
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener("click", function (e) {
                e.preventDefault();
                prevSlide();
            });
        }
    }    
    
    const mobileIcon = document.querySelector('.mobile-icon');
    const searchIcon = document.querySelector('.search-icon');

    if (mobileIcon) {
        mobileIcon.addEventListener('click', function () {
            document.body.classList.toggle('mobile-opened');
        });
    }

    if (searchIcon) {
        searchIcon.addEventListener('click', function () {
            document.body.classList.toggle('search-opened');
        });
    }

    document.querySelectorAll('.tab-headings a').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            if (!this.classList.contains('active-tab')) {

                document.querySelectorAll('.tab-headings a').forEach(el => {
                    el.classList.remove('active-tab');
                });

                document.querySelectorAll('.tab-content').forEach(el => {
                    el.classList.remove('active');
                });

                const target = document.querySelector(this.getAttribute('href'));

                this.classList.add('active-tab');

                if (target) {
                    target.classList.add('active');

                    if (typeof jQuery !== 'undefined') {
                        jQuery(target).find('.tab-products').slick('setPosition');
                    }
                }
            }
        });
    });

    document.querySelectorAll('.tab-selects select').forEach(select => {
        select.addEventListener('change', function () {

            document.querySelectorAll('.tab-content').forEach(el => {
                el.classList.remove('active');
            });

            const target = document.querySelector(this.value);

            if (target) {
                target.classList.add('active');

                if (typeof jQuery !== 'undefined') {
                    jQuery(target).find('.tab-products').slick('setPosition');
                }
            }
        });
    });

    document.querySelectorAll('.faq h3').forEach(heading => {
        heading.addEventListener('click', function () {
            const parent = this.parentElement;
            parent.classList.toggle('faq-opened');
        });
    });

    document.querySelector('.header-cart')?.addEventListener('click', e => {
        e.preventDefault();
        openCart();
    });

    document.querySelectorAll('.bins-cart-close, .bins-cart-overlay')
        .forEach(el => el.addEventListener('click', e => {
            e.preventDefault();
            closeCart();
        }
    ));

    document.querySelectorAll('.footer-menu-heading').forEach(heading => {
        heading.addEventListener('click', function () {

            if (window.innerWidth < 1201) {
                const parent = this.parentElement;

                document.querySelectorAll('.footer-menu-opened').forEach(el => {
                    if (el !== parent) {
                        el.classList.remove('footer-menu-opened');
                    }
                });

                parent.classList.toggle('footer-menu-opened');
            }
        });
    });

    const headerSwitch = document.querySelector('input[name="header-switch"]');

    headerSwitch?.addEventListener('change', function () {
        const isChecked = this.checked;

        const wrapper = document.querySelector('.header .switch-wrapper');
        const vatText = document.querySelector('.header .vat-text');

        if (isChecked) {
            wrapper?.classList.add('header-vat-active');
            if (vatText) vatText.textContent = 'Inc. VAT';

            if (document.querySelector('.best-sellers')) {
                changeBestSellers(true);
            }

            if (document.querySelector('.featured-collections')) {
                changeFCPrice(true);
            }

            if (document.querySelector('.collection-wrap')) {
                changeCollectionPrice(true);
            }

            if (document.querySelector('.product-main')) {
                const vatSwitch = document.querySelector('#vat-switch');
                if (vatSwitch) {
                    vatSwitch.checked = true;
                    vatSwitch.dispatchEvent(new Event('change'));
                }
            }

            setCookie('vat_active', 1, 1);

        } else {
            wrapper?.classList.remove('header-vat-active');
            if (vatText) vatText.textContent = 'Ex. VAT';

            if (document.querySelector('.best-sellers')) {
                changeBestSellers(false);
            }

            if (document.querySelector('.featured-collections')) {
                changeFCPrice(false);
            }

            if (document.querySelector('.collection-wrap')) {
                changeCollectionPrice(false);
            }

            if (document.querySelector('.product-main')) {
                const vatSwitch = document.querySelector('#vat-switch');
                if (vatSwitch) {
                    vatSwitch.checked = false;
                    vatSwitch.dispatchEvent(new Event('change'));
                }
            }

            setCookie('vat_active', 0, 1);
        }
    });

    const vatActive = getCookie('vat_active');
    const headerSwitchInit = document.querySelector('input[name="header-switch"]');

    if (headerSwitchInit) {
        headerSwitchInit.checked = !!vatActive;
        headerSwitchInit.dispatchEvent(new Event('change'));
    }

    document.addEventListener('click', function (e) {
        const removeBtn = e.target.closest('.cart-item-remove');
        if (!removeBtn) return;

        e.preventDefault();

        showLoader();

        const floatEl = document.querySelector('.bins-cart-float');
        if (floatEl) {
            floatEl.style.display = 'none';
        }

        const cartItem = removeBtn.closest('.bins-cart-item');
        const cartKey = cartItem?.dataset.id;

        const formData = {
            id: cartKey,
            quantity: 0
        };

        fetch(window.Shopify.routes.root + "cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(formData)
        })
        .then(res => res.json())
        .then(() => {
            renderCartDrawer();
        })
        .catch(err => console.error("Error removing item:", err));
    });

    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.qtty span');
        if (!btn) return;

        const wrapper = btn.parentElement;
        const input = wrapper.querySelector('input[name="qtty"]');

        let currentVal = parseInt(input.value, 10) || 1;

        if (btn.classList.contains('plus')) {
            currentVal++;
        } else {
            currentVal = currentVal > 1 ? currentVal - 1 : 1;
        }

        input.value = currentVal;

        const cartItem = btn.closest('.bins-cart-item');
        const itemId = cartItem?.dataset.id;

        if (itemId) {
            updateCart(itemId, currentVal);
        }
    });

    document.addEventListener('change', function (e) {
        const input = e.target.closest('input[name="qtty"]');
        if (!input) return;

        const currentVal = parseInt(input.value, 10) || 1;

        const cartItem = input.closest('.bins-cart-item');
        const itemId = cartItem?.dataset.id;

        if (itemId) {
            updateCart(itemId, currentVal);
        }
    });

    const placeholder = document.querySelector('.livechat');
    
    if (!placeholder) return;
    
    placeholder.addEventListener('click', function() {
        placeholder.remove();
        loadTidio();
    });

    renderCartDrawer();
});